import React from 'react';
import {useTheme, useMediaQuery, Grid2 } from '@mui/material';
import * as S from './Styled';
import {beneficiosImage} from '../../../../constants/Home/aboutClubImages';
import {cuponsImage} from '../../../../constants/Home/aboutClubImages';

const AboutSection = () => {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <S.SectionContainer component="section" aria-labelledby="about-title">
            <Grid2
                container
                spacing={1}
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
            >
                <Grid2
                container
                alignItems="center"
                justifyContent="center"
                flexDirection={isMobile || isTablet ? 'column' : 'row'}
                >
                <Grid2 item sx={{ position: 'relative', order: isTablet ? 2 : 1,}}>
                    <S.ImageBox>
                        <img
                            src={beneficiosImage}
                            alt="Imagem explicativa do MeuCupom Clubes"
                            
                        />
                        <S.FloatingTickets>
                            <img
                            src={cuponsImage}
                            alt="Imagem dos cupons"
                            />
                        </S.FloatingTickets>
                    </S.ImageBox>
                </Grid2>
                <S.ResponsiveGridItem item xs={12} md={6} tabletOrder={1}> 
                    <S.SectionBox>
                        <S.SectionTitle id="about-title" variant="h4">
                            O QUE É?
                        </S.SectionTitle>
                        <S.SectionText>
                            O <strong>MeuCupom Clubes</strong> é um <strong>Clube de Benefícios</strong> que surge com o objetivo de atender
                            empresas interessadas em conquistar e aumentar o relacionamento com seus colaboradores, assinantes, associados e
                            clientes através de <strong>cupons e ofertas exclusivas</strong> nos maiores e-Commerce do Brasil, gerando ainda
                            <strong> mais valor para sua marca.</strong>
                        </S.SectionText>

                        <S.SectionText>
                            Nosso Clube conta com mais de 1.800 marcas parceiras dentro de um ambiente totalmente customizável e exclusivo.
                            O acesso é restrito com o intuito de garantir a melhor experiência para o usuário e o caráter exclusivo dos
                            descontos ofertados.
                        </S.SectionText>

                        <S.SectionText>
                            Faça parte do <strong>Clube de Benefícios MeuCupom Clubes</strong> e garanta o crescimento do seu negócio
                            oferecendo <strong>OS MELHORES DESCONTOS</strong> para os seus clientes, colaboradores, assinantes e associados!
                        </S.SectionText>
                    </S.SectionBox>
                </S.ResponsiveGridItem>
            </Grid2>
        </Grid2>
        </S.SectionContainer>
    );
};

export default AboutSection;
